import { getAppInfo } from './getters/get_app_info'
import { getBrowserEnv } from './getters/get_browser_env'
import { getPlatform } from './getters/get_platform'
import { getDeviceId } from './getters/get_device_id'
import { miniProgramEnv } from './getters/detect_mp'
import { getAppVersion } from './getters/get_app_version'
import { getAppKey } from './getters/get_app_key'
import { eventbus } from '@/utils/eventbus'
import { EventNames } from '../events'
import { getThirdSource } from './getters/get_third_source'
import { getWechatGray } from './getters/get_wechat_gray'

export { miniProgramEnv } from './getters/detect_mp'
export const appInfo = getAppInfo()
export const browserEnv = getBrowserEnv()
export const platform = getPlatform()
export let deviceId = getDeviceId(platform, appInfo)
export let appVersion = getAppVersion(appInfo, miniProgramEnv)
export let appKey = getAppKey(appInfo, miniProgramEnv)
export let thirdSource = getThirdSource()
export let weChatKfGray = getWechatGray(appInfo, miniProgramEnv)

eventbus.addEventListener(EventNames.miniProgramDetected, () => {
  // Android 小程序 webview 这里同步更新不了，暂且 setTimeout 大法异步一下
  setTimeout(() => {
    appVersion = getAppVersion(appInfo, miniProgramEnv)
    thirdSource = getThirdSource()
    deviceId = getDeviceId(platform, appInfo)
    appKey = getAppKey(appInfo, miniProgramEnv)
    weChatKfGray = getWechatGray(appInfo, miniProgramEnv)
  }, 0)
})
